import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../components/Layout';
import { Card } from '../design-system';

const Contact: React.FC = () => {
  return (
    <Layout>
      <div className="max-w-5xl mx-auto space-y-20">
        {/* Hero Section */}
        <div className="text-center">
          <h1 className="mb-4 text-4xl font-bold text-white lg:text-5xl">Get in Touch</h1>
          <p className="max-w-2xl mx-auto text-lg text-white/80">
            Have questions or need support? We're here to help. Reach out through any of the channels below.
          </p>
        </div>

        {/* Contact Methods */}
        <div className="grid gap-6 md:grid-cols-2">
          <Card padding="lg" hover>
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary-500/20">
                <span className="text-2xl">📧</span>
              </div>
              <div className="flex-1">
                <h3 className="mb-2 text-xl font-bold text-white">Email</h3>
                <a
                  href="mailto:support@incupie.com"
                  className="block mb-1 text-lg transition-colors text-primary-400 hover:text-primary-300"
                >
                  support@incupie.com
                </a>
                <p className="text-sm text-white/60">Available 24/7 • Response within 24 hours</p>
              </div>
            </div>
          </Card>

          <Card padding="lg" hover>
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary-500/20">
                <span className="text-2xl">📞</span>
              </div>
              <div className="flex-1">
                <h3 className="mb-2 text-xl font-bold text-white">Phone</h3>
                <a
                  href="tel:+919915080818"
                  className="block mb-1 text-lg transition-colors text-primary-400 hover:text-primary-300"
                >
                  +91-9915080818
                </a>
                <p className="text-sm text-white/60">Mon-Fri • 9:00 AM - 6:00 PM IST</p>
              </div>
            </div>
          </Card>

          <Card padding="lg" hover>
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary-500/20">
                <span className="text-2xl">💬</span>
              </div>
              <div className="flex-1">
                <h3 className="mb-2 text-xl font-bold text-white">Discord Community</h3>
                <a
                  href="https://discord.gg/7WsMfhweUs"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="block mb-1 text-lg transition-colors text-primary-400 hover:text-primary-300"
                >
                  Join our Discord
                </a>
                <p className="text-sm text-white/60">Chat available on our Discord community</p>
              </div>
            </div>
          </Card>

          <Card padding="lg" hover>
            <div className="flex items-start gap-4">
              <div className="flex items-center justify-center w-12 h-12 rounded-lg bg-primary-500/20">
                <span className="text-2xl">📍</span>
              </div>
              <div className="flex-1">
                <h3 className="mb-2 text-xl font-bold text-white">Office</h3>
                <p className="mb-1 text-white/80">
                  No. 19, 4th C Cross Koramangala Industrial<br />
                  5th Block, Bengaluru, Karnataka 560095, India
                </p>
              </div>
            </div>
          </Card>
        </div>

        {/* Social Links */}
        <div className="text-center">
          <h2 className="mb-6 text-2xl font-bold text-white">Follow Us</h2>
          <div className="flex flex-wrap justify-center gap-4">
            <a
              href="https://x.com/incupie"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 transition-all rounded-lg bg-primary-500/20 border border-primary-500/30 text-primary-400 hover:bg-primary-500/30 hover:text-primary-300 hover:border-primary-400"
            >
              Twitter
            </a>
            <a
              href="https://github.com/incupie"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 transition-all rounded-lg bg-primary-500/20 border border-primary-500/30 text-primary-400 hover:bg-primary-500/30 hover:text-primary-300 hover:border-primary-400"
            >
              GitHub
            </a>
            <a
              href="https://www.linkedin.com/company/incupie/"
              target="_blank"
              rel="noopener noreferrer"
              className="px-6 py-3 transition-all rounded-lg bg-primary-500/20 border border-primary-500/30 text-primary-400 hover:bg-primary-500/30 hover:text-primary-300 hover:border-primary-400"
            >
              LinkedIn
            </a>
          </div>
        </div>

        {/* Resource Links */}
        <div>
          <h2 className="mb-6 text-2xl font-bold text-center text-white">Resources</h2>
          <div className="grid gap-4 sm:grid-cols-3">
            <Link to="/terms" className="block group">
              <Card hover className="h-full" padding="md">
                <h3 className="mb-1 font-semibold text-white transition-colors group-hover:text-primary-400">
                  Terms of Service
                </h3>
                <p className="text-sm text-white/60">Our terms and conditions</p>
              </Card>
            </Link>
            <Link to="/privacy" className="block group">
              <Card hover className="h-full" padding="md">
                <h3 className="mb-1 font-semibold text-white transition-colors group-hover:text-primary-400">
                  Privacy Policy
                </h3>
                <p className="text-sm text-white/60">How we protect your data</p>
              </Card>
            </Link>
            <Link to="/refund" className="block group">
              <Card hover className="h-full" padding="md">
                <h3 className="mb-1 font-semibold text-white transition-colors group-hover:text-primary-400">
                  Refund Policy
                </h3>
                <p className="text-sm text-white/60">Cancellations and refunds</p>
              </Card>
            </Link>
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Contact;
